<template>
    <div class="page-content" id="profile-list">
        <Titlebar :incrustation="'fa-cogs'">
            <h1>{{ $t('profile.titles.list') }}</h1>
        </Titlebar>
        <UiCard>
            <SuperTable
                ref="tableIdentifications"
                :tableColumns="tableColumns"
                :tableData="tableData"
                @sort="handleSort"
                @filter="handleFilter"
                @copy="handleCopy"
                @delete="handleDelete" 
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn class="default" v-can="'beepiz-add-profiles'" to="/configurations/profiles/new">
                        <i class="fa fa-plus"></i><span>{{ $t('profile.btns.add') }}</span>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>

        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Utils from '@/services/utils.js'

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from '@/components/ui/Card';
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";

    import ProfileRenderer from "@/components/profiles/ProfileRenderer";
    import ProfileCountRenderer from "@/components/profiles/list/table-renderer/ProfileCountRenderer";

    import find from 'lodash/find';
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'ProfilesList',
        components: {
            UiCard,
            Titlebar,
            Toolbar,
            Btn,
            Pagination,
            SuperTable
        },
        data: () => ({
            count: 0,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: ['+name']
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('profile.emptyTable')
                },
                columns: [
                    {
                        key: 'meta.default',
                        label: '',
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: false,
                        filter: false,
                        width: '20px',
                        renderer: function(item){
                            if(item.meta.default == 1){
                                return '<i class="fa fa-star default-profile-marker"></i>'
                            }
                            return '';
                        }
                    },{
                        key: 'name',
                        label: Utils.t('profile.name'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: '+',
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '50%',
                        renderer: ProfileRenderer
                    },
                    {
                        key: 'count',
                        label: Utils.t('profile.nbdevices'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '30%',
                        renderer: ProfileCountRenderer
                    }

                ],
                rowActions:{
                    width: '15%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: [

            ]

        }),

        methods: {
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function(item){
                window.V._router.push('/configurations/profiles/'+item.profileId+'/copy');
            },
            handleDelete: function(item){
                var vThis = this;
                if (item.meta.default == 1) {
                    window.Vfc.$refs.messages.sendMessage('error', Utils.t('profile.errors.noDeleteDefault'));
                    return false;
                }
                if (item.count > 0) {
                    window.Vfc.$refs.messages.sendMessage('error', Utils.t('profile.errors.noDeleteProfileLinked'));
                    return false;
                }
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: function () {
                        axios.delete(API.route(API.endpoints.profiles.delete, {profileId: item.profileId}))
                            .then(response => {
                                if(vThis.tableData.length == 1 && vThis.config.page > 1){
                                    vThis.config.page--;
                                }
                                vThis.loadData();
                            })
                    }
                });

            },
            loadData: function(){
                axios.get(API.endpoints.profiles.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);

                        var defaultProfile = find(this.tableData,function(item){ return item.meta.default == 1});
                        if(defaultProfile){
                            defaultProfile.spRowClassname = "no-delete-action";
                        }

                        window.Vfc.$refs.loading.hide();
                    })
            }
        },

        created(){

        },

        watch:{
            tableData: {
                handler: function(val){
                }
            }
        },

        mounted(){
            if (!useDvFlagAccess("beepiz-profile-can:read")) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'profiles'} })
            } else {
                if(!useDvFlagAccess("beepiz-profile-can:delete")){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }
                if(!useDvFlagAccess("beepiz-profile-can:create")){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }

                this.loadData();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
